import { render, staticRenderFns } from "./RangeSlider.vue?vue&type=template&id=5bc4274e&"
import script from "./RangeSlider.vue?vue&type=script&lang=ts&"
export * from "./RangeSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports